import * as React from "react";
import {
  Box,
  Typography,
  Link,
  Grid,
  Container,
  Button,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import SubscriptionSection from "../../widgets/footer/subscription_section";
import ContactUs from "../../../../Components/Widgets/Dialogs/ContactUs";
import { isMobile } from "react-device-detect";

const BRAND = "#f05d32";

function DevelopedBy() {
  return (
    <Box
      sx={{
        bgcolor: "#111",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        pt: 2,
        pb: isMobile ? "66px" : 2,
      }}
    >
      <Typography variant="body2" align="center" sx={{ color: "#818181" }}>
        {"Developed by "}
        <Link
          color="inherit"
          href="https://www.automatapp.com/"
          underline="hover"
          sx={{ fontWeight: 600, "&:hover": { color: "#fff" } }}
        >
          Automatapp
        </Link>{" "}
        {new Date().getFullYear()}
      </Typography>
    </Box>
  );
}

const FooterTitle = styled(Typography)(() => ({
  fontSize: "18px",
  color: "#fff",
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  marginBottom: "18px",
  position: "relative",
  paddingBottom: "10px",
  "&::after": {
    content: '""',
    position: "absolute",
    left: 0,
    bottom: 0,
    width: 28,
    height: 2,
    backgroundColor: BRAND,
    borderRadius: 1,
  },
}));

const FooterLink = styled(Link)(() => ({
  textDecoration: "none",
  color: "#bdbdbd",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  fontSize: "15px",
  fontWeight: 500,
  lineHeight: 1.4,
  transition: "color 0.2s ease",
  "&:hover": {
    color: "#fff",
  },
}));

const IconWrap = styled(Box)(() => ({
  width: 36,
  height: 36,
  borderRadius: "50%",
  backgroundColor: "rgba(240, 93, 50, 0.12)",
  color: BRAND,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  fontSize: 15,
}));

const SpotCard = styled(Box)(() => ({
  padding: "14px 0",
  "& + &": {
    borderTop: "1px solid rgba(255,255,255,0.1)",
  },
}));

export default function StickyFooter(props) {
  const { component } = props;
  const filesUrl = component.getHelpers("env").get("files_url");
  const img_version = component.getHelpers("value").getValue("images-version");

  const [contactUsOpen, setContactUsOpen] = React.useState(false);

  const spots = [
    // {
    //   nameKey: "ampelokipoi",
    //   phoneKey: "ampelokipoi-phone-number",
    //   mapUrl:
    //     "https://www.google.com/maps/place/PIZZA+Il+Palatino/@37.9912039,23.7648425,17z/data=!3m2!4b1!5s0x14a19806db2da169:0x3e2f2324c08e09f1!4m5!3m4!1s0x14a19806c516739f:0xb2339eea7d0c632b!8m2!3d37.9911997!4d23.7670312",
    // },
    {
      nameKey: "zografou-address",
      phoneKey: "zografou-phone-number",
      mapUrl:
        "https://www.google.com/maps/place/Pizza+IL+Palatino+%CE%96%CF%89%CE%B3%CF%81%CE%AC%CF%86%CE%BF%CF%85/@37.9828913,23.7601499,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd5593cd9781:0x3856fd2097baefec!8m2!3d37.9828871!4d23.7623386",
    },
  ];

  const apps = [
    {
      slug: "wolt",
      name: "Wolt",
      url: "https://wolt.com/el/grc/athens/restaurant/il-palatino?srsltid=AfmBOoqHy1bw53ScXCotW2lnJIlcbm-7hlWuJsY184CfanOzav6dBg0c",
    },
    {
      slug: "box",
      name: "Box",
      url: "https://box.gr/delivery/goudi/il-palatino-goudi",
    },
    {
      slug: "efood",
      name: "Efood",
      url: "https://www.e-food.gr/delivery/menu/il-palatino",
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        backgroundColor: "#0a0a0a",
      }}
    >
      <SubscriptionSection {...props} />
      <Container maxWidth="lg" sx={{ pb: 2, pt: 5 }}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          rowSpacing={{ xs: 4 }}
          columnSpacing={{ xs: 4, md: 6 }}
        >
          <Grid item xs={12} sm={6} lg={4}>
            <FooterTitle>{component.trans("footer-title-1")}</FooterTitle>
            {spots.map((spot) => (
              <SpotCard key={spot.nameKey}>
                <FooterLink
                  href={spot.mapUrl}
                  target="_blank"
                  rel="noreferrer"
                  sx={{ mb: 1.25 }}
                >
                  <IconWrap>
                    <i className="fa-light fa-store" />
                  </IconWrap>
                  {component.trans(spot.nameKey)}
                </FooterLink>
                <FooterLink
                  href={"tel:" + component.trans(spot.phoneKey)}
                  sx={{ pl: "48px", fontSize: 14, color: "#9a9a9a" }}
                >
                  <i
                    className="fa-light fa-phone"
                    style={{ marginRight: 8, color: BRAND, fontSize: 13 }}
                  />
                  {component.trans(spot.phoneKey)}
                </FooterLink>
              </SpotCard>
            ))}
          </Grid>

          <Grid item xs={12} sm={6} lg={4}>
            <FooterTitle>Delivery</FooterTitle>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.25, mb: 4 }}>
              {apps.map((app) => {
                const { slug, name, url } = app;
                return (
                  <Link
                    key={slug}
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    sx={{
                      display: "block",
                      borderRadius: "12px",
                      overflow: "hidden",
                      bgcolor: "rgba(255,255,255,0.06)",
                      p: 0.75,
                      transition: "background 0.2s ease, transform 0.2s ease",
                      "&:hover": {
                        bgcolor: "rgba(255,255,255,0.12)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardMedia
                      sx={{ width: 72, display: "block" }}
                      component="img"
                      image={`${filesUrl}/assets/images/${slug}.png?v=${img_version}`}
                      alt={`${name} image`}
                    />
                  </Link>
                );
              })}
            </Box>

            <FooterTitle>{component.trans("footer-title-3")}</FooterTitle>
            <Link
              href="https://www.facebook.com/ilpalatino.gr"
              target="_blank"
              rel="noreferrer"
              aria-label="facebook"
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "rgba(255,255,255,0.06)",
                color: "#fff",
                transition: "background 0.2s ease, color 0.2s ease",
                "&:hover": {
                  bgcolor: BRAND,
                  color: "#fff",
                },
              }}
            >
              <i className="fa-brands fa-facebook" style={{ fontSize: 22 }} />
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} lg={4}>
            <FooterTitle>{component.trans("footer-title-2")}</FooterTitle>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
              <FooterLink
                href={"mailto:" + component.trans("shop-email")}
                target="_blank"
                rel="noreferrer"
              >
                <IconWrap>
                  <i className="fa-light fa-envelope" />
                </IconWrap>
                {component.trans("shop-email")}
              </FooterLink>
              <Button
                onClick={() => setContactUsOpen(true)}
                sx={{
                  p: 0,
                  minWidth: 0,
                  justifyContent: "flex-start",
                  textTransform: "none",
                  color: "#bdbdbd",
                  fontSize: 15,
                  fontWeight: 500,
                  gap: "12px",
                  "&:hover": {
                    bgcolor: "transparent",
                    color: "#fff",
                  },
                }}
              >
                <IconWrap>
                  <i className="fa-light fa-comment" />
                </IconWrap>
                {component.trans("contact-form")}
              </Button>
            </Box>
            <Box
              component="img"
              sx={{
                height: { xs: 40, md: 44 },
                mt: 3,
                opacity: 0.9,
                filter: "grayscale(0.2)",
              }}
              alt="payment-type-cards"
              src="/images/cards.png"
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 4,
            pt: 2.5,
            borderTop: "1px solid rgba(255,255,255,0.08)",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography sx={{ fontSize: 13, color: "#888" }}>
            {`© ${new Date().getFullYear()} Il Palatino`}
          </Typography>
          <Link
            component={RouterLink}
            to="/terms-and-conditions/terms-of-use"
            underline="hover"
            sx={{
              fontSize: 13,
              color: "#888",
              "&:hover": { color: "#fff" },
            }}
          >
            {component.trans("terms-and-conditions")}
          </Link>
        </Box>
      </Container>
      <DevelopedBy />
      <ContactUs
        {...{
          ...props,
          ...{
            open: contactUsOpen,
            setOpen: (boolean) => setContactUsOpen(boolean),
          },
        }}
      />
    </Box>
  );
}
